import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import NavigationLayout from "../../Components/NavigationLayout";
import Edit from "./Edit";

const Pages = () => {
  return (
    <NavigationLayout>
      <Router history={history}>
        <Switch>
          <Route exact path="/admin/pages" component={List} />
          <Route path="/admin/pages/new" component={Add} />
          <Route path="/admin/pages/:id" component={Edit} />
        </Switch>
      </Router>
    </NavigationLayout>
  );
};
export default Pages;
